import { serializable, alias, object, list, primitive } from 'serializr';

export class MyPlan {
  @serializable(alias('plan_name', primitive()))
  planName?: string;

  @serializable(alias('price', primitive()))
  price?: number;

  @serializable(alias('created_at', primitive()))
  createdAt?: string;

  @serializable(alias('valid_upto', primitive()))
  validUpto?: string;
}
